import BaseLayer from "./BaseLayer";
import {plotDisagreementTextv2Unit} from "../utils/map_utils";

class StitchDisagreementTextv2 extends BaseLayer {

    id = "stitchDisagreementTextv2";
    label = "Text";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchDisagreement, textColor, textSize} = this.props;
        stitchDisagreement = stitchDisagreement.result;
        const margin = 3 / 10;
        const sizeOfMarker = 0.2;
        for (const key in stitchDisagreement) {
            // sample key is "x9y32.jpg"
            const xHori = parseInt(key.split('y')[0].split('x')[1]);
            const yVerti = parseInt(key.split('y')[1].split('.' + this.props.slide.img_type)[0]);
            const disagreement = stitchDisagreement[key];
            plotDisagreementTextv2Unit(disagreement, this.props.slide, xHori, yVerti, margin, sizeOfMarker,
                this.layer.getSource(), textColor, textSize);
        }
        resolve();
    });
}

export default StitchDisagreementTextv2;
